<template>
  <div>
    <el-card body-style="height:570px">
      <div slot="header" class="clearfix">
        <span>投入品管理</span>
      </div>
      <el-row :gutter="20">
        <el-col
          :span="4"
          style="height: 620px; border-right: 1px solid #f1f1f1"
        >
          <div style="padding: 10px; border-bottom: 1px solid #f1f1f1">
            <el-radio-group v-model="radio">
              <el-radio
                style="width: 120px;padding: 3px"
                v-for="(item, key) in radioOptions"
                :key="key"
                :label="item"
                @change="select"
                >{{ item }}</el-radio
              >
            </el-radio-group>
          </div>
          <div style="padding: 10px">
            <p>
              <router-link :to="{ path: './inputs/newone' }">
                <el-button size="small" style="width: 180px" type="primary"
                  >向资料库中录入新的投入品
                </el-button>
              </router-link>
            </p>
            <p></p>
          </div>
        </el-col>
        <el-col :span="20">
          <inputs-table
            :data="inputs"
            :title="title"
            :inputsRunning="inputsRunning"
            @refreshData="refreshData"
          />
          <div style="margin-top: 5px; text-align: right">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageNum"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="value"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import {
  getInputs,
  updateInputs,
  deleteInputs,
  getInputsByEnterpriseId,
} from '@/api/inputs.js'
import { getDataByEnterpriseId ,invoiceList} from '@/api/inputs-invoice.js'
import InputsTable from './InputsTable'
export default {
  components: { InputsTable },
  data() {
    return {
      radio: '库存', // 复选框
      radioOptions: ['库存', '流水', '资料库'], // 复选框数据
      btnOptions: [], //操作按钮
      title: '库存', // 表格标题
      inputsAll: [],
      arrSearch: [], //搜索输入框
      inputs: [],
      state: '', //搜索输入框
      pageNum: 1, //分页
      pageSize: 10,
      value: 10,
      total: 0,
      multipleSelectionOwned: [], //左侧选中的数组
      deleteRowsBtn: true,
      inputsRunning:[]
    }
  },
  created() {
    this.getInputsOwned()
  },
  mounted() {
    // 搜索框内容
    getInputs().then((r) => {
      this.arrSearch = r.data.list.map((item) => {
        return { value: item.name }
      })
    })
  },
  methods: {
    // 单选框
    select(value) {
      this.title = value
      this.pageNum = 1
      this.pageSize = 10
      this.value = 10
      this.total = 0
      switch (value) {
        case '库存':
          this.getInputsOwned()
          break
        case '资料库':
          this.getInputsAll()
          break
        case '流水':
          this.getInputsRunning()
          break
      }
    },
    getInputsRunning() {
      let option={
        pageNum:this.pageNum,
        pageSize:this.pageSize
      }
      invoiceList(this.$store.getters.currentEnterprise.id,option).then(data=>{
        console.log(data)
        this.total = data.data.total
        this.inputsRunning=data.data.list.map(item=>{
          return {
            weightUnit:
              item.packingWeight +
              item.unit +
              (item.packagingForm === '' ? '' : '/' + item.packagingForm),
            numFormat:
              item.num + item.packagingForm+`,合计${item.num*item.packingWeight}${item.unit}`,
            disabled: false,
            ...item,
          }
        })
      })
    },
    // 获取公司投入品-接口
    getInputs(enterpriseId, params) {
      let option={
        pageNum:this.pageNum,
        pageSize:this.pageSize
      }
      if (enterpriseId) {
        getDataByEnterpriseId(enterpriseId,option).then((r) => {
          this.total = r.data.total
          this.inputs = r.data.list.map((item) => {
            return {
              weightUnit:
                item.packingWeight +
                item.unit +
                (item.packagingForm === '' ? '' : '/' + item.packagingForm),
              numFormat:
                item.num + item.packagingForm+`,合计${item.num*item.packingWeight}${item.unit}`,
              disabled: false,
              ...item,
            }
          })
        })
      } else {
        getInputs(params).then((r) => {
          this.total = r.data.total
          this.inputs = r.data.list.map((item) => {
            return {
              weightUnit:
                item.packingWeight +
                item.unit +
                (item.packagingForm === '' ? '' : '/' + item.packagingForm),
              disabled: false,
              ...item,
            }
          })
          this.$nextTick(() => {
            this.inputs.forEach((a) => {
              this.inputsAll.forEach((b) => {
                if (a.id === b.id) {
                  b.disabled = true
                }
              })
            })
          })
        })
      }
    },
    // 删除投入品-接口
    delInputs(data) {
      deleteInputs(data)
    },
    // 录入投入品
    getInputsAll() {
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }
      this.getInputs('', params)
    },
    // 公司投入品
    getInputsOwned() {
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }
      this.getInputs(this.$store.getters.currentEnterprise.id, params)
    },
    // 刷新数据
    refreshData(value) {
      this.getInputsOwned()
    },
    // 通过选项获取数据
    getDataByTitle() {
      switch (this.title) {
        case '库存':
          this.getInputsOwned()
          break
        case '资料库':
          this.getInputsAll()
          break
      }
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val
      this.getDataByTitle()
      this.getInputsRunning()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getDataByTitle()
      this.getInputsRunning()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/resource/inputs/Index.vue